import { StaggeredPackageBuilderModel } from './staggered-package-builder.model';
import { MakeYearModel } from './make-year-model.model';

export class PackageBuilderPackage {
  public package: StaggeredPackageBuilderModel;
  public makeYearModel: MakeYearModel;
  public customerId: string;
  public searchLogId: number;

  constructor() {
    this.package = new StaggeredPackageBuilderModel();
    this.customerId = sessionStorage.getItem("customerID");
  }
}
